import React from 'react';

const MoodDataContext = React.createContext(null);

export default MoodDataContext;
